import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { API } from "@/App";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const photoSrc = (url) => (url && url.startsWith("/api") ? `${BACKEND}${url}` : url);

const layouts = [
  "md:col-span-8 md:row-span-2 h-72 md:h-full",
  "md:col-span-4 h-64",
  "md:col-span-4 h-64",
  "md:col-span-5 h-64",
  "md:col-span-7 h-64",
];

export default function Gallery() {
  const [photos, setPhotos] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/gallery`)
      .then(({ data }) => setPhotos(data))
      .catch(() => {});
  }, []);

  return (
    <section id="galerie" className="bg-white py-20 lg:py-32" data-testid="gallery-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-12 flex flex-col justify-between gap-4 sm:flex-row sm:items-end"
        >
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">La Galerie</p>
            <h2 className="mt-4 font-serif text-3xl font-semibold tracking-tight text-stone-900 sm:text-4xl">
              Les coulisses de <span className="italic text-burgundy">l'apprentissage</span>
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-stone-500">
            Gestes précis, concentration et fierté : plongez dans le quotidien de nos élèves,
            entre cuisine et salle.
          </p>
        </motion.div>

        {photos.length > 0 && (
          <div className="grid grid-cols-1 gap-4 md:grid-cols-12 md:grid-rows-2">
            {photos.map((f, i) => (
              <motion.figure
                key={f.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: (i % 5) * 0.08 }}
                whileHover={{ y: -4 }}
                className={`group relative overflow-hidden ${layouts[i % layouts.length]}`}
                data-testid={`gallery-frame-${i}`}
              >
                <img
                  src={photoSrc(f.url)}
                  alt={f.caption || "Photo du restaurant"}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-burgundy-deep/60 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                {f.caption && (
                  <figcaption className="absolute bottom-0 left-0 translate-y-3 p-5 font-mono text-[10px] uppercase tracking-[0.25em] text-gold-light opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                    {f.caption}
                  </figcaption>
                )}
              </motion.figure>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
